<template lang="pug">
  img.img-circle.profileImage(
    v-if='object && object.hasPicture', 
    :src='object.picture',
    :title='object.name', 
    :class='{user: object.kind == "user", group: object.kind == "group", private: object.kind == "group" && object.isPublic === false, public: object.kind == "group" && object.isPublic}', 
    @click="$emit('click')")
  .profileImage.ll(
    v-else-if='object && !object.hasPicture', 
    :title='object.name', 
    :class='{user: object.kind == "user", group: object.kind == "group", private: object.kind == "group" && object.isPublic === false, public: object.kind == "group" && object.isPublic}', 
    :style='{backgroundColor: color() }', 
    @click="$emit('click')")
      | {{ object.name | initials }}
</template>
<script>
import {mapGetters} from 'vuex'

export default {
  props: ['object', 'editable'],
  mounted () {
    if (!this.object) {
      return
    }
    this.fixPicture()
  },
  computed: {
    ...mapGetters('user', [
      'user'
    ])
  },
  methods: {
    'color': function () {
      var colors
      if (this.object == null) {
        return '#FFFFFF'
      }
      colors = ['#bd61a1', '#b7419f', '#315cb5', '#109150', '#46cccb', '#df5c29', '#3d9a5a', '#80a45f', '#bdebae', '#c376c9', '#7d1de3', '#75d352', '#ec1afd', '#64b5fc', '#26989b', '#302b76', '#d96600', '#e26a4b', '#ce222c', '#8409d1']
      return colors[this.object.id % colors.length]
    },
    fixPicture () {
      if (this.object && this.object.kind === 'group' && (this.object.id === '-2' || this.object.isIndividual)) {
        this.object.hasPicture = this.user.hasPicture
        this.object.picture = this.user.picture
      }
    }
  },
  filters: {
    'initials': function (value) {
      var parts
      if (value == null) {
        return ''
      }
      parts = value.toLowerCase().replace('les ', ' ').replace('le ', ' ').replace('la ', ' ').replace(' de ', ' ').replace(' du ', ' ').replace(' et ', ' ').replace(/[^0-9a-zA-Z- \u00C0-\u017F]/g, '').match(/(^|\s)[0-9a-z\u00C0-\u017F]/g)
      if (parts != null) {
        return parts.join('').replace(/\s+/g, '').toUpperCase().slice(0, 3)
      }
      return '?'
    }
  },
  watch: {
    object () {
      this.fixPicture()
    }
  }
}
</script>



// WEBPACK FOOTER //
// VueObjectImg.vue?9f38c38e